
<app-video-loader #videoLoaderRef/>

<app-say-good-bye-view />

<div 
  [style.view-transition-name]="'standby-video'"
  class="home__overlay"
></div>

<div 
  class="home__bg-animatted-video"
  [class.immersive-mode-start]="srcImmersiveVideo() ? true : false"
  [class.immersive-mode-end]="!immersiveModeActived()"
></div>

@if(srcImmersiveVideo()) {
  <video 
    #immersiveVideoRef
    class="home__animatted-video"
    [src]="srcImmersiveVideo()"
  ></video>
}

<main 
  class="home__main"
  [class.immersive-mode-start]="srcImmersiveVideo() ? true : false"
  [class.immersive-mode-end]="!immersiveModeActived()"
>
  <app-suggestions />

  <div class="home__router">
    <router-outlet />
  </div>

  <app-info-and-chat [chatId]="chatId()" />
</main>
